const React = require("react");
import * as actions from "../actions/";
import { connect } from "react-redux";
import axios from "axios";
const qs = require("querystring");
export class StoreStar extends React.Component {
    constructor() {
        super(...arguments);
        this.editFavorites = () => {
            var _a;
            if (this.props.favoriteStores &&
                this.props.IncrementFavorite &&
                this.props.DecrementFavorite &&
                this.props.ToggleLogin) {
                if (this.props.authenticated) {
                    let FavoriteStore = this.props.favoriteStores.indexOf(this.props.id) === -1
                        ? [
                            ...this.props.favoriteStores,
                            this.props.id
                        ].toString()
                        : this.props.favoriteStores
                            .filter((x) => {
                            return x !== this.props.id;
                        })
                            .toString();
                    let antiForgery = (_a = document.querySelector('html').getAttribute('data-antiforgery')) !== null && _a !== void 0 ? _a : '';
                    axios
                        .post("/Manage/SetFavoriteStore", qs.stringify({
                        FavoriteStore
                    }), {
                        headers: {
                            "X-XSRF-TOKEN": antiForgery
                        }
                    })
                        .then(() => {
                        this.props.favoriteStores.indexOf(this.props.id) === -1
                            ? this.props.IncrementFavorite(this.props.id)
                            : this.props.DecrementFavorite(this.props.id);
                    });
                }
                else {
                    this.props.ToggleLogin();
                }
            }
            if (this.props.UpdateStores) {
                this.props.UpdateStores();
            }
        };
    }
    render() {
        let classStyle = this.props.favoriteStores &&
            this.props.favoriteStores.indexOf(this.props.id) === -1
            ? "fa fa-star-o fav-star"
            : "fa fa-star fav-star";
        return React.createElement("i", { className: classStyle, onClick: this.editFavorites });
    }
}
export const mapStateToProps = ({ shoppingList, authenticated, signInModal, favoriteStores }, ownProps) => {
    return {
        favoriteStores,
        authenticated
    };
};
export function mapDispatchToProps(dispatch) {
    return {
        DecrementFavorite: (store) => dispatch(actions.DecrementFavorite(store)),
        IncrementFavorite: (store) => dispatch(actions.IncrementFavorite(store)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(StoreStar);
//# sourceMappingURL=store-star.js.map